
(function(){
  var S = window.QP_STRINGS || {};
  var money = function(cents){
    try{ return '\u00A3' + (cents/100).toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    catch(e){ return '\u00A3' + (cents/100).toFixed(2); }
  };
  var $ = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  // mobile menu
  var burger = $('#burger');
  if(burger){ burger.addEventListener('click', function(){ $('#navlinks').classList.toggle('open'); }); }

  // toast
  var toastTimer;
  function toast(msg){
    var t = $('#toast'); if(!t) return;
    $('#toastMsg').textContent = msg || S.added || 'Added to bag';
    t.classList.add('show'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2200);
  }

  // drawer
  var overlay = $('#overlay'), drawer = $('#drawer');
  function openDrawer(){ if(overlay&&drawer){ overlay.classList.add('show'); drawer.classList.add('show'); refresh(); } }
  function closeDrawer(){ if(overlay&&drawer){ overlay.classList.remove('show'); drawer.classList.remove('show'); } }
  $$('[data-cart-toggle]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); }); });
  if(overlay) overlay.addEventListener('click', closeDrawer);
  var dclose = $('#drawerClose'); if(dclose) dclose.addEventListener('click', closeDrawer);

  function setCount(n){ $$('.cart-count').forEach(function(el){ el.textContent = n; }); }

  function renderDrawer(cart){
    var items = $('#cartItems'), foot = $('#drawerFoot');
    if(!items||!foot) return;
    setCount(cart.item_count);
    if(cart.item_count === 0){
      items.innerHTML = '<div class="cart-empty-d"><span class="stripe lg"><i></i><i></i><i></i></span><p style="margin-top:18px">' + (S.empty || 'Your bag is empty.') + '</p></div>';
      foot.innerHTML = '<a class="btn btn-ghost" href="/collections/all" style="width:100%;justify-content:center">' + (S.startShopping || 'Start shopping') + '</a>';
      return;
    }
    items.innerHTML = cart.items.map(function(it){
      var img = it.image ? '<img src="'+it.image+'" alt="">' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="ci-var">'+it.variant_title+'</div>' : '';
      return '<div class="citem"><div class="ci-img">'+img+'</div><div class="ci-info"><h4>'+it.product_title+'</h4>'+variant+
        '<div class="ci-bottom"><div class="ci-qty"><button data-line="'+it.key+'" data-q="'+(it.quantity-1)+'">\u2212</button><span>'+it.quantity+'</span><button data-line="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button></div>'+
        '<span class="ci-price">'+money(it.final_line_price)+'</span></div>'+
        '<a class="ci-remove" data-line="'+it.key+'" data-q="0">Remove</a></div></div>';
    }).join('');
    foot.innerHTML = '<div class="ctotal"><span class="l">' + (S.subtotal || 'Subtotal') + '</span><span class="v">'+money(cart.total_price)+'</span></div>'+
      '<p class="note">' + (S.taxesNote || 'Shipping &amp; taxes calculated at checkout.') + '</p>'+
      '<a class="btn btn-primary" href="/checkout">' + (S.checkout || 'Checkout') + ' \u2192</a>';
    $$('.ci-qty button, .ci-remove', items).forEach(function(b){
      b.addEventListener('click', function(){ changeLine(b.getAttribute('data-line'), b.getAttribute('data-q')); });
    });
  }

  function refresh(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderDrawer).catch(function(){});
  }
  function changeLine(key, q){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity: parseInt(q,10)})})
      .then(function(r){return r.json();}).then(renderDrawer).catch(function(){});
  }

  function addId(id, qty){
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id: id, quantity: qty||1})})
      .then(function(r){ if(!r.ok){ throw r; } return r.json(); })
      .then(function(){ toast('Added to bag'); openDrawer(); })
      .catch(function(){ toast('Could not add — try again'); });
  }

  // quick add buttons (product cards)
  $$('[data-quick-add]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      addId(b.getAttribute('data-quick-add'), 1);
    });
  });

  // product form ajax
  var pform = $('#AddToCartForm');
  if(pform){
    pform.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(pform);
      var id = fd.get('id'); var qty = parseInt(fd.get('quantity')||'1',10);
      addId(id, qty);
    });
    // qty stepper
    var qm = $('#qtyMinus'), qp = $('#qtyPlus'), qi = $('#qtyInput');
    if(qm&&qp&&qi){
      qm.addEventListener('click', function(){ qi.value = Math.max(1, (parseInt(qi.value,10)||1)-1); });
      qp.addEventListener('click', function(){ qi.value = (parseInt(qi.value,10)||1)+1; });
    }
    // variant -> price + gallery
    var vsel = $('#variantSelect');
    if(vsel){
      vsel.addEventListener('change', function(){
        var opt = vsel.options[vsel.selectedIndex];
        var price = opt.getAttribute('data-price');
        var pe = $('#pdPrice'); if(pe && price) pe.firstChild ? pe.firstChild.nodeValue = price : pe.textContent = price;
      });
    }
  }

  // product gallery thumbs
  $$('.pd-thumbs button').forEach(function(b){
    b.addEventListener('click', function(){
      var src = b.getAttribute('data-full');
      var main = $('#pdMainImg'); if(main&&src){ main.src = src; }
      $$('.pd-thumbs button').forEach(function(x){ x.classList.remove('active'); });
      b.classList.add('active');
    });
  });
})();


/* ===== Header: mobile nav drill-down (global chrome) =====
   Car finder and FAQ behaviour now live in their own sections'
   {% javascript %} blocks (sections/car-finder.liquid, sections/faq.liquid). */
(function(){
  Array.prototype.forEach.call(document.querySelectorAll('.navtop'), function(a){
    a.addEventListener('click', function(e){
      if(window.innerWidth <= 640){
        e.preventDefault();
        var g=a.parentElement, was=g.classList.contains('open');
        Array.prototype.forEach.call(document.querySelectorAll('.navgroup'), function(x){ x.classList.remove('open'); });
        if(!was) g.classList.add('open');
      }
    });
  });
})();


(function(){
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function starHTML(n){ var s=''; for(var i=1;i<=5;i++){ s+='<span class="'+(i<=n?'on':'')+'">\u2605</span>'; } return s; }
  function fmt(d){ try{ return new Date(d).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}); }catch(e){ return d||''; } }

  function init(root){
    var api = (root.getAttribute('data-api')||'').replace(/\/+$/,'');
    var scope = root.getAttribute('data-scope')||'shop';
    var listEl=root.querySelector('[data-rev-list]'), avgEl=root.querySelector('[data-rev-avg]'),
        starsEl=root.querySelector('[data-rev-avgstars]'), countEl=root.querySelector('[data-rev-count]'),
        pick=root.querySelector('[data-rev-pick]'), nameEl=root.querySelector('[data-rev-name]'),
        carEl=root.querySelector('[data-rev-car]'), textEl=root.querySelector('[data-rev-text]'),
        hpEl=root.querySelector('[data-rev-hp]'), btn=root.querySelector('[data-rev-submit]'),
        noteEl=root.querySelector('[data-rev-note]');
    var rating=0;
    function note(m){ if(noteEl){ noteEl.textContent=m; noteEl.style.display='block'; } }
    function setRating(n){ rating=n; if(pick){ Array.prototype.forEach.call(pick.children,function(b,i){ b.classList.toggle('on', i<n); }); } }
    if(pick){ Array.prototype.forEach.call(pick.children,function(b,i){ b.addEventListener('click',function(){ setRating(i+1); }); }); }

    function render(data){
      var reviews=(data&&data.reviews)||[];
      var avg=reviews.length?reviews.reduce(function(s,r){return s+(+r.rating||0);},0)/reviews.length:0;
      if(avgEl) avgEl.textContent=reviews.length?avg.toFixed(1):'\u2014';
      if(starsEl) starsEl.innerHTML=starHTML(Math.round(avg));
      if(countEl) countEl.textContent=reviews.length+(reviews.length===1?' review':' reviews');
      if(listEl){
        listEl.innerHTML = reviews.length ? reviews.map(function(r){
          return '<div class="rev-card"><div class="rev-top"><span class="stars">'+starHTML(r.rating)+'</span><span class="rev-date">'+fmt(r.date)+'</span></div>'+
            '<p class="rev-text">'+esc(r.text)+'</p><div class="rev-who"><b>'+esc(r.name||'Anonymous')+'</b>'+(r.car?' <span>\u00b7 '+esc(r.car)+'</span>':'')+'</div></div>';
        }).join('') : '<p class="rev-empty">No reviews yet \u2014 be the first to leave one.</p>';
      }
    }
    function load(){
      if(!api){ note('Reviews are not configured yet.'); return; }
      fetch(api+'/api/reviews?scope='+encodeURIComponent(scope),{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();}).then(render).catch(function(){ render({reviews:[]}); });
    }
    if(btn){ btn.addEventListener('click',function(){
      if(!api){ note('Reviews are not configured yet.'); return; }
      var text=(textEl&&textEl.value||'').trim();
      if(!rating){ note('Please pick a star rating'); return; }
      if(!text){ note('Please write a short review'); return; }
      btn.disabled=true;
      fetch(api+'/api/reviews',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
        scope:scope, rating:rating, text:text,
        name:(nameEl&&nameEl.value||'').trim(), car:(carEl&&carEl.value||'').trim(), hp:(hpEl&&hpEl.value||'')
      })}).then(function(r){return r.json();}).then(function(res){
        btn.disabled=false;
        if(res&&res.ok){ if(textEl)textEl.value=''; if(nameEl)nameEl.value=''; if(carEl)carEl.value=''; setRating(0); note('Thanks \u2014 your review is live'); load(); }
        else { note((res&&res.error)||'Could not post review'); }
      }).catch(function(){ btn.disabled=false; note('Could not reach the review service'); });
    }); }
    load();
  }
  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-qp-reviews]'), init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
